import {
  LoadingScheduleState,
  ScheduleByIdSessionRequest,
  ScheduleRequest,
  WeeklyScheduleRequest,
  GenerateTracksRequest,
  AddUserToScheduleRequest,
  TransferLearnerRequest,
} from '@tsin-core/models/schedule.model';

export class CreateSchedule {
  static readonly type = '[Schedule] Create';
  constructor(public payload: Omit<ScheduleRequest, 'id'>) { }
}

export class CreateWeeklySchedule {
  static readonly type = '[Schedule] Create Weekly';
  constructor(public payload: Omit<WeeklyScheduleRequest, 'id'>) { }
}

export class GetSchedulesByLearning {
  static readonly type = '[Schedule] Get';
  constructor(public learningId: string) { }
}

export class GetWeeklySchedules {
  static readonly type = '[Schedule] Get Weekly Schedule';
}

export class GetScheduleByIdSession {
  static readonly type = '[Schedule] By Id and Session';
  constructor(public payload: ScheduleByIdSessionRequest) { }
}

export class GetSingleSchedules {
  static readonly type = '[Schedule] Get Single';
}

export class GetSchedulesExportData {
  static readonly type = '[Schedule] Get Schedules Export Data';
  constructor(public payload: string) { }
}

export class SetLoading {
  static readonly type = '[Schedule] Set Loading';
  constructor(public loading: LoadingScheduleState) { }
}

export class SetError {
  static readonly type = '[Schedule] Set Error';
  constructor(public error: string | null) { }
}


// ============================================================================
// NEW ACTIONS FOR ALGORITHM UPDATE & AI/ML
// ============================================================================

export class GenerateTracksWithOptions {
  static readonly type = '[Schedule] Generate Tracks With Options';
  constructor(public payload: GenerateTracksRequest) { }
}

export class ValidateSchedule {
  static readonly type = '[Schedule] Validate Schedule';
  constructor(public weeklyScheduleId: string) { }
}

export class AddUserWithPlacement {
  static readonly type = '[Schedule] Add User With Placement';
  constructor(public payload: AddUserToScheduleRequest) { }
}

export class CollectFeedback {
  static readonly type = '[Schedule] Collect Feedback';
  constructor(public weeklyScheduleId: string) { }
}

/**
 * Transfer a learner from one weekly schedule to another, then re-run the
 * leadership repair algorithm on the target schedule.
 *
 * Transférer un apprenant vers un autre horaire hebdomadaire, puis relancer
 * l'algorithme de réparation du leadership sur l'horaire cible.
 */
export class TransferLearner {
  static readonly type = '[Schedule] Transfer Learner';
  constructor(public payload: TransferLearnerRequest) {}
}

export class GetAIStatus {
  static readonly type = '[Schedule] Get AI Status';
}

/**
 * Fetch all learners enrolled in a given weekly schedule.
 * Used to populate the Transfer Learner source-learner dropdown.
 *
 * Récupère tous les apprenants inscrits dans un horaire hebdomadaire donné.
 * Utilisé pour peupler la liste déroulante de l'apprenant source dans le transfert.
 */
export class GetLearnersForSchedule {
  static readonly type = '[Schedule] Get Learners For Schedule';
  constructor(public weeklyScheduleId: string) {}
}
